// extracted by css-extract-rspack-plugin
export default {"Box":"archive-header-wrapper-module__Box__IUm9lQ8","Box_1":"archive-header-wrapper-module__Box_1__OWf6w3K"};